import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const warehouseModule: ForqModuleManifest = {
  id: 'warehouse',
  name: 'Lager & Bestand',
  description: 'Lagerplätze, Bestände, Bewegungen und Beschaffungsvorschläge',
  version: '0.1.0',
  route: '/lager',
  category: 'operations',
  status: 'development',
  requiredPermissions: ['warehouse.view'],
  features: [
    'warehouse.overview',
    'warehouse.stock',
    'warehouse.movements',
    'warehouse.locations',
    'warehouse.replenishment',
    'warehouse.inventory',
  ],
  navigation: [
    { id: 'warehouse.primary', label: 'Lager & Bestand', route: '/lager', placement: 'primary', order: 40, icon: 'lager' },
    { id: 'warehouse.launcher', label: 'Lager & Bestand', route: '/lager', placement: 'launcher', order: 40, icon: 'lager' },
  ],
};

export const warehouseFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'warehouse.overview', moduleId: 'warehouse', name: 'Übersicht',
    description: 'Bestandskennzahlen und aktuelle Lagerlage', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['warehouse.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed', 'warehouse.movement.posted'],
  },
  {
    id: 'warehouse.stock', moduleId: 'warehouse', name: 'Bestände',
    description: 'Artikelbestände je Lagerplatz', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['warehouse.stock.view'], uiSlots: [], emits: [], listensTo: ['warehouse.movement.posted'],
  },
  {
    id: 'warehouse.movements', moduleId: 'warehouse', name: 'Bestandsbewegungen',
    description: 'Zugänge, Abgänge, Umlagerungen und Korrekturen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['warehouse.movements.view'], uiSlots: [], emits: ['warehouse.movement.posted'], listensTo: ['tenant.changed'],
  },
  {
    id: 'warehouse.locations', moduleId: 'warehouse', name: 'Lagerplätze',
    description: 'Physische Lagerorte und Standardlager', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['warehouse.locations.view'], uiSlots: [], emits: ['warehouse.location.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'warehouse.replenishment', moduleId: 'warehouse', name: 'Beschaffungsvorschläge',
    description: 'Unterdeckungen nach Mindestbestand und bevorzugtem Lieferanten', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['warehouse.replenishment.view'], uiSlots: [], emits: [], listensTo: ['warehouse.movement.posted', 'masterdata.item.changed'],
  },
  {
    id: 'warehouse.inventory', moduleId: 'warehouse', name: 'Inventur',
    description: 'Stichtagsinventur: Zählliste erfassen und Differenzen als Korrektur buchen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['warehouse.stock.view'], uiSlots: [], emits: ['warehouse.movement.posted'], listensTo: ['tenant.changed'],
  },
];
